import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { noteActions } from 'store';
import { PermissionList, RolePermission, useModal, User } from 'utils';
import { ApptDetailRow, LinkRow } from 'components';
import { MarkResolved } from './markResolved';
import { ApptNoteActions } from './apptNoteActions';
import { FormBuilderProvider } from '../../../../../pages/forms/formDetail';
import { ReportBuilder } from '../../../../../pages/forms/progressReport/reportBuilder';
import { LocalDateRow } from '../../../../../components';

export const SessionNoteDetails = ({ note, appt, afterSuccess, single, serviceTemplate, notNeedActions }) => {
    const { open } = useModal();
    const { userInfo } = User();
    const dispatch = useDispatch();

    useEffect(() => {
        if (note?.id) dispatch(noteActions.viewNote({ ids: [note.id] }));
    }, [note?.id]);

    return (
        <div style={{ width: 816 }}>
            <div>
                <div className="session-note-title-box">
                    <div className="session-note-title">
                        <p>{note?.template?.title}</p>
                    </div>

                    {!notNeedActions && (
                        <div>
                            <ApptNoteActions
                                reverse={true}
                                apptId={appt?.id}
                                noteType={note?.type}
                                item={note}
                                appt={appt}
                                serviceTemplate={serviceTemplate}
                                single={true}
                            />
                        </div>
                    )}
                </div>
            </div>

            <div className="session-note-appt-info" style={{ marginTop: '20px' }}>
                <div className="session-note-appt-info-box">
                    <p className="session-note-appt-info-box-title">Appt ID:</p>
                    <div>
                        <ApptDetailRow
                            name={appt?.apptDisplayId || appt?.displayId}
                            id={appt?.id}
                            afterSuccess={afterSuccess}
                            showWidth={'auto'}
                        />
                    </div>
                </div>
                <div className="session-note-appt-info-box">
                    <p className="session-note-appt-info-box-title">Created:</p>
                    <div className="flex-align-center full-width" style={{ fontSize: 14, gap: 4 }}>
                        <p className="session-note-appt-info-box-value">
                            {/*{note?.createdDate ? moment.utc(note?.createdDate).format('MM/DD/YY, hh:mma') : '-'} by*/}
                            {note?.createdDate ? <LocalDateRow date={note?.createdDate} /> : '-'} by
                        </p>
                        <LinkRow
                            name={note?.creatorFullName}
                            href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${note?.creatorId}` : ''}
                            checkPermission={note?.creatorId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                            textWidth={8}
                        />
                    </div>
                </div>
                {note?.updatedDate && note?.updaterFullName && (
                    <div className="session-note-appt-info-box">
                        <p className="session-note-appt-info-box-title">Last Updated:</p>
                        <div className="flex-align-center full-width" style={{ fontSize: 14, gap: 4 }}>
                            <p className="session-note-appt-info-box-value">
                                {/*{note?.updatedDate ? moment.utc(note?.updatedDate).format('MM/DD/YY, hh:mma') : '-'} by*/}
                                {note?.updatedDate ? <LocalDateRow date={note?.createdDate} /> : '-'} by
                            </p>
                            <LinkRow
                                name={note?.updaterFullName}
                                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${note?.updaterId}` : ''}
                                checkPermission={note?.updaterId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                                textWidth={8}
                            />
                        </div>
                    </div>
                )}
            </div>

            {note?.template && (
                <div className="note-detail-body-info-box">
                    <FormBuilderProvider initialFormList={note.template} initialImageUrls={note.template?.imageUrls}>
                        <ReportBuilder isDetail />
                    </FormBuilderProvider>
                </div>
            )}

            {note?.requestedBy && note?.requestedDate && note?.requestedMessage && !note?.resolvedDate && (
                <div className="session-note-update-request">
                    <div className="update-request-title-box">
                        <p>Update Request</p>
                        {userInfo?.id === note?.creatorId && (
                            <button
                                className="request-note"
                                onClick={() => open(<MarkResolved note={note} apptId={appt?.id} single={single} />)}>
                                Mark as Resolved
                            </button>
                        )}
                    </div>
                    <div className="requested-info-box">
                        <p style={{ marginBottom: 4 }}>{`Requested by ${note?.requestedBy} on ${moment(note?.requestedDate).format(
                            'MM/DD/YY [at] hh:mm A'
                        )}`}</p>
                        <p>{`Message:  ${note?.requestedMessage ? note?.requestedMessage : 'No Message'}`}</p>
                    </div>
                </div>
            )}
        </div>
    );
};
